// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMsg_error__3JtDO"};